import ServiceHookFactory from "utilities/services/service-hook-factory";
import EnhancedContentResourceRecord from "models/view-models/enhanced-content-resource-record";

// ---------------------------------------------------------------------------------------------
// #region Interfaces
// ---------------------------------------------------------------------------------------------

export interface SharedEnhancedContentResourceBasePathParams {
    pageGuid: string;
}

/**
 * Search parameters when listing EnhancedContentResource records.
 * These get translated to QueryString parameters
 */
export interface SharedEnhancedContentResourceListQueryParams {
    enhancedContentIds?: number[];
    recipient?: string;
}

// #endregion Interfaces

// ---------------------------------------------------------------------------------------------
// #region Constants
// ---------------------------------------------------------------------------------------------

const baseEndpoint = "public/pages/:pageGuid/enhancedcontentresources";
const resourceType = EnhancedContentResourceRecord;

// #endregion Constants

// ---------------------------------------------------------------------------------------------
// #region Service
// ---------------------------------------------------------------------------------------------

const SharedEnhancedContentResourceService = {
    useBatchList: ServiceHookFactory.useNestedBatchedList<
        EnhancedContentResourceRecord,
        SharedEnhancedContentResourceBasePathParams,
        SharedEnhancedContentResourceListQueryParams
    >(resourceType, baseEndpoint),
};

// #endregion Service

// ---------------------------------------------------------------------------------------------
// #region Exports
// ---------------------------------------------------------------------------------------------

export default SharedEnhancedContentResourceService;

// #region Exports
